var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',{staticStyle:{"background":"#11679a !important","padding":"20px"}},[_c('a',{staticStyle:{"font-weight":"bold","font-size":"15px","color":"white"}},[_vm._v("@ GootWork Technologies Inc. 2019")])])}
var staticRenderFns = []

export { render, staticRenderFns }